export default {
  isEmpty: (state) => !state.items.length
}
